import MyTable from "../../Component/MyTable"
import AddIcon from '@mui/icons-material/Add';
import { MenuItem, ListItemIcon, ListItemText, Alert, Paper, Toolbar, Typography, Button, Stack, Snackbar,   ButtonGroup,  Box } from "@mui/material";
import { useEffect, useState } from "react";
import { apiResult,  getUserSession,   } from "../../Utils/Common";
import apis from "../../api";
import { RightDrawer } from "../../Component/MuiEx";
import { useNavigate, } from "react-router";
import DownMenuItem from "../../Component/DownMenuItem"
import { getItemsFromObjects,   settingDataLoader } from "../../Component/DataLoader";
import EditPackageCourse from "./fragement/EditPackageCourse";

const PackageCourses = () => {    
    const [rightDrawer, setRightDrawer] = useState()
    const [hintMsg, setHintMsg] = useState()
    const [datas, setDatas] = useState([])
    const [terms,setTerms] = useState()
    const [error, setError] = useState()
    const navigate = useNavigate()
    const [autoCloseRightDraw, setAutoCloseRightDraw] = useState(true)
    const session = getUserSession(apis)        
    const handleHintClose = () => {
        setHintMsg()
    }
    const loadData = () => {        
        // loadPackages(0,apis,setDatas,setError,1)
        apis.packageCourseGet().then(ret=>{
            apiResult(ret,setDatas,setError)
        })
    }    
    let initPage = false
    useEffect(() => {
        if (initPage) return
        initPage = true
        settingDataLoader('term',1,apis,setTerms,setError)
        loadData()
        
    }, [])

    const handleAfterEdit = (idx, data, err, errs) => { 
        data.description = encodeURIComponent(data.description)       
        apis.packageCoursePost(data).then(ret => {
            apiResult(ret, (data) => {                
                setAutoCloseRightDraw(true)
                setRightDrawer(false)
                loadData()
            }, setError)
        })
    }
    const handleRightDrawer = () => {
        if (autoCloseRightDraw)
            setRightDrawer(false)
    }
    const handleAdd = () => {
        setAutoCloseRightDraw(false)
        setRightDrawer(<EditPackageCourse data={{ id: 0 }} onSubmit={(data, err, errs) => { handleAfterEdit(-1, data, err, errs) }} onClose={() => { setRightDrawer(false) }} />)
    }
    const handleDelete = (idx, item) => {
        apis.packageCourseDelete(item.id).then(ret => {
            apiResult(ret, data => {
                let cc = [...datas]
                cc[idx].status = 0
                setDatas(cc)
            }, setError)
        })
    }
    const handleEnable = (idx, item) => {
        apis.packageCoursePut({ id: item.id, status: 1 }).then(ret => {
            apiResult(ret, data => {
                let cc = [...datas]
                cc[idx].status = 1
                setDatas(cc)
            }, setError)
        })
    }
    const TableHeader = [
        { name: 'id', showName: 'ID' },
        { name: 'term_id',showName:'Term',func:(v,idx,row)=>{
            return getItemsFromObjects(terms,v)?.name
        }},
        { name: 'category_id', showName: 'Course',func:(v,idx,row)=>{
            return <Box><a href={"/course/coursecategory/"+v.category_id} target={"category_"+v.category_id}>{row.course_category?.name}</a> / {row.course_id>0?<a href={"/course/course/"+row.course_id} target={"course_"+row.course_id}>{row.course?.name}</a>:"*"}</Box>
        } },        
        { name:'lessons',showName:"Lessons"},
        { name:'lessonduration',showName:"Minutes"},
        { name:'price',showName:"Lesson Price(before tax)"},
        { name:'tax',showName:"Tax",func:(v,i,row)=>{
            return (v*100).toFixed(2)  + "%"
        }},
        { name:'total',showName:"Total Price(included tax)",func:(v,i,row)=>{
            return (Number(row.lessons) * Number(row.price) * (1+Number(row.tax))).toFixed(2)
        }},
        { name: 'description',showName:'Description',func:(v,idx,item)=>{
            v = decodeURIComponent(v)
            return v.substring(0,50) + (v.length>50?'...':'')
        }},        
        {
            name: 'option', showName: 'Options', func: (v, idx, item) => {
                return <ButtonGroup size="small" variant="contained" aria-label="outlined primary button group">
                    {session.mid == item.mid && <Button variant={item.status == 0 ? "outlined" : "contained"} onClick={() => item.status != 0 ? handleDelete(idx, item) : handleEnable(idx, item)}>{item.status == 0 ? 'Disable' : 'Enable'}</Button>}                    
                </ButtonGroup>
            }
        },
    ]
    const OptionButton = [
        { text: "Add", icon: <AddIcon fontSize="small" />, onClick: handleAdd },
    ]
    return (
        <>
            {/* <Backdrop open={loading} /> */}
            {error && <Alert severity={"warning"} sx={{ width: '100%', marginTop: "5px", mb: 2 }} onClose={() => setError()}>{error}</Alert>}
            <Paper sx={{ marginBottom: 2 }}>
                <Toolbar style={{ paddingLeft: 2 }}>
                    <Stack direction={{ xs: 'column', sm: 'row' }}>
                        {OptionButton.map((item, index) => {
                            return item.subItems ? <DownMenuItem key={index} icon={item.icon} onClick={item.onClick} items={item.subItems} text={item.text} /> :
                                <MenuItem key={index} onClick={item.onClick}>
                                    {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}<ListItemText>{item.text}</ListItemText>
                                </MenuItem>
                        })}
                    </Stack>
                    <Typography sx={{ flex: '1 1 100%' }} variant="h6" component="div" ></Typography>
                </Toolbar>
            </Paper>
            {datas.length == 0 && <Alert severity={"info"}>Ops! There is not any data</Alert>}
            {datas.length > 0 && <MyTable
                height={650}
                rows={datas}
                totalRow={datas.length}
                headers={TableHeader}
                checkbox={false}
                rowsPerPage={20}
            />}
            {hintMsg && <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={hintMsg ? true : false} autoHideDuration={3000} onClose={handleHintClose}>
                <Alert onClose={handleHintClose} severity="success" sx={{ width: '100%' }}>{hintMsg}</Alert>
            </Snackbar>}
            <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
                {rightDrawer}
            </RightDrawer>
        </>

    )
}
export default PackageCourses